import { forwardRef } from 'react'
import { Loading } from '@winnin/winnin_ui.components.loading'

import { Error } from 'components'
import { useTranslate } from 'lib/tolgee'
import { TOLGEE_GLOBALS } from 'utils'

import { translations } from './zai-iframe-provider.i18n'
import type { IZaiIframeProviderRef, IZaiIframeProviderViewProps } from './zai-iframe-provider.types'
import { zaiUtils } from '../common/zai.utils'

import './zai-iframe-provider.styles.scss'

export const ZaiIframeProviderView = forwardRef<IZaiIframeProviderRef, IZaiIframeProviderViewProps>(
  (
    {
      workspaceId,
      module,
      language,
      hasError,
      isLoading,
      threadId,
      threadPrompt,
      threadPromptPage,
      quickPromptId,
      handleRetry,
      handleIframeError,
      handleIframeLoad,
      isZaiRagEnabled,
    },
    ref
  ) => {
    const t = useTranslate()

    if (hasError) {
      return (
        <div className="ZaiIframeProvider-error">
          <Error
            errorMessage={t(translations.errorMessage)}
            buttonText={t(TOLGEE_GLOBALS.retry)}
            handleError={handleRetry}
          />
        </div>
      )
    }

    return (
      <div className="ZaiIframeProvider-container">
        {isLoading && (
          <div className="ZaiIframeProvider-loading">
            <Loading />
          </div>
        )}
        <iframe
          ref={ref}
          src={`${zaiUtils.generateZaiChatSrc({ workspaceId, module, language, threadId, threadPrompt, threadPromptPage, quickPromptId, isZaiRagEnabled })}`}
          className="ZaiIframeProvider-iframe"
          allow="clipboard-read; clipboard-write"
          onLoad={handleIframeLoad}
          onError={handleIframeError}
        />
      </div>
    )
  }
)
